<template>
  <div>
    <div class="subject" v-for="(item, index) in SsoSubject" v-if="jobList.length">
      <Select
        v-model="item.seriesId"
        placeholder="请选择一级"
        class="selectCity"
        @on-change="changeOne($event, index)"
      >
        <Option :value="String(0)" label="其他"></Option>
        <Option v-for="(ite, i) in jobList" :value="ite.id" :key="i">{{
          ite.name
        }}</Option>
      </Select>
      <Select
        v-model="item.levelTwo"
        placeholder="请选择二级"
        class="selectCity"
        @on-change="changeTwo($event, index)"
      >
        <Option v-for="(ite, i) in gradeList" :value="ite.id" :key="i">{{
          ite.name
        }}</Option>
      </Select>
      <Select
        v-if="item.seriesId && item.seriesId != 0"
        v-model="item.id"
        placeholder="请选三级"
        class="selectCity"
        @on-change="changeThree($event, index)"
      >
        <Option v-for="(ite, i) in item.listThree" :value="ite.id" :key="i">{{
          ite.titleName
        }}</Option>
      </Select>
      <Input
        v-if="item.seriesId == 0"
        v-model="item.titleName"
        @on-blur="blurCus"
        autocomplete="off"
        style="width: 150px"
        placeholder="请填写"
      />
      <Button
        v-if="SsoSubject.length != 1"
        type="error"
        icon="md-remove"
        @click="removeSubject(index)"
        >移除</Button
      >
    </div>
    <!--<Button class="add" type="info" icon="md-add" @click="addSubject()">添加</Button>-->
  </div>
</template>
<script>
let vm;
export default {
  props: {
    subjectList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      jobList: [],
      SsoSubject: [
        { seriesId: "", gradeId: "", levelTwo: "", id: "", titleName: "", listThree: [] },
      ],
      gradeList: [
        { id: "senior", name: "正高级" },
        { id: "subSenior", name: "副高级" },
        { id: "middle", name: "中级" },
        { id: "elementary", name: "初级" },
      ],
      grades: ["senior", "subSenior", "middle", "elementary"],
    };
  },
  mounted() {
    vm = this;
    vm.getJobList();
  },
  methods: {
    getJobList() {
      vm.$apis.manage.titleList().then((result) => {
        if (result.messageType == "Success") {
          vm.jobList = result.content.list;
          if (!vm.subjectList.length) return;
          vm.SsoSubject = vm.subjectList.map((item) => {
            item.levelTwo = vm.grades[item.gradeId - 1];
            item.listThree = vm.mapJobList(item.seriesId, item.levelTwo);
            item.seriesId = item.seriesId == 0 ? String(item.seriesId) : item.seriesId;
            return item;
          });
        }
      });
    },
    mapJobList(seriesId, gradeId) {
      let data = {};
      vm.jobList.forEach((item) => {
        if (item.id == seriesId) {
          data = item[gradeId];
        }
      });

      return data;
    },
    addSubject() {
      let data = {
        seriesId: "",
        gradeId: "",
        levelTwo: "",
        id: "",
        titleName: "",
        listThree: [],
      };
      if (vm.SsoSubject.length == 10) {
        this.$Message.destroy();
        this.$Message.error("最多添加10条数据！");
        return;
      }
      for (var i = 0; i < vm.SsoSubject.length; i++) {
        if (!vm.SsoSubject[i].id) {
          this.$Message.destroy();
          this.$Message.error("请先完成上一条职称！");
          return;
        }
      }
      vm.SsoSubject.push(data);
    },
    removeSubject(index) {
      vm.SsoSubject.splice(index, 1);
      vm.$emit("fun", vm.SsoSubject);
    },
    changeOne(val, index) {
      vm.SsoSubject[index].gradeId = "";
      vm.SsoSubject[index].id = "";
      vm.SsoSubject[index].levelTwo = "";
      vm.SsoSubject[index].titleName = "";
      vm.$emit("fun", vm.SsoSubject);
    },
    changeTwo(val, index) {
      let item = vm.SsoSubject[index];
      vm.SsoSubject[index].id = "";
      vm.SsoSubject[index].listThree = vm.mapJobList(item.seriesId, item.levelTwo);
      vm.$emit("fun", vm.SsoSubject);
    },
    changeThree(val, index) {
      vm.$emit("fun", vm.SsoSubject);
    },
    blurCus() {
      vm.$emit("fun", vm.SsoSubject);
    },
  },
};
</script>
<style scoped>
.selectCity {
  width: 200px;
  display: inline-block;
  vertical-align: middle;
}
.w250 {
  width: 650px;
}
.w2 {
  width: 200px;
}
.subject {
  margin-bottom: 20px;
}
.f18 :first-child {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/job.vue